import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { TableColumn, TableColumnTypeEnum } from '@oranta-mis/ui-library';

export const rehabilitationOrderListColumnHeader = (i18n: TranslocoHelper): TableColumn[] => [
  {
    type: TableColumnTypeEnum.text,
    key: 'rehabilitation_program',
    name: i18n.tr('rehabilitation_programs'),
  },
  {
    type: TableColumnTypeEnum.actions,
    key: 'actions',
    name: i18n.tr('actions'),
    actions: ['details', 'pay', 'cancel'],
  },
];
